export enum WizardSteps {
  CHOOSE_ACCOUNT,
  FORM,
  CONFIRMATION,
  SUCCESS
}
